import { styled } from '@linaria/react';
import { MIN_NAV_HEIGHT } from '../../../components/nav-bar/NavBar.components';
import { MOBILE_MEDIA_QUERY } from '../../global.linaria.global';
import { HERO_IMAGE_HREFS } from '../../../hero-image';

export const HeroSectionBlurHashFallbackWrapper = styled.div`
	position: relative;
	overflow: hidden;
`;

export const HeroSectionBlurHashFallbackBackdrop = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: #d0d884;
	filter: blur(47px) !important;
`;

export const HeroSectionBlurHashFallbackHighRes = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
    background-size: cover;
`;

export const HeroSectionContainer = styled.section`

    &:before {
        position: absolute;
        content: " ";
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.35rem;
        background: linear-gradient(to top, #1f1f1f, rgba(0, 0, 0, 0));
    }


    min-height: max(calc(100svh + ${200 - MIN_NAV_HEIGHT}px), 50vw);
    @media ${MOBILE_MEDIA_QUERY} { min-height: max(600px, 100svh + ${200 - MIN_NAV_HEIGHT}px, 50vw); }

    padding: 2rem;

    background-image: image-set(
        ${HERO_IMAGE_HREFS.map(([href, type]) => `url("${href}") type("${type}")`).join(', ')}
    );
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #0000;

    background-position: 32.25% 40%;


    position: relative;
    overflow: hidden;

    display: flex;
    align-items: flex-start;
    justify-content: center;
`;

export const HeroContent = styled.div`
    display: grid;
    grid-template-columns: repeat(13, 1fr);
    padding: 2rem;
    padding-top: min(1.4vw, 2rem);
    width: 100%;
    align-items: center;

    @media ${MOBILE_MEDIA_QUERY} {
        text-align: center;
        gap: 2rem;
        grid-template-columns: 1fr;
        grid-template-rows: min-content minmax(300px, 0.8fr) minmax(300px, 1fr);
        grid-auto-flow: column;
        justify-items: center;

        @media (min-width: 600px) {
            position: absolute;
            box-sizing: border-box;
            height: 100%;
        }
    }
`;

export const HeroTextArea = styled.div`
    color: white;
    background-color: rgba(0, 0, 0, 0.85);
    box-shadow: 0 0 15px 1rem rgba(0, 0, 0, 0.85);
    padding: 3rem;
    margin: 1rem;
    z-index: 2;
    grid-column: 7 / -1;
    min-width: min-content;
    max-width: 800px;

    @media ${MOBILE_MEDIA_QUERY} {
        padding: 2rem;
        margin: 0 -1.5rem;
        grid-column: 1;
        grid-row: 1;
        box-sizing: border-box;
    }
`;

export const DesktopHeroLongContent = styled.div`
    @media ${MOBILE_MEDIA_QUERY} {
        display: none;
    }
`;

export const MobileHeroLongContent = styled.div`
    display: none;

    @media ${MOBILE_MEDIA_QUERY} {
        display: unset;
    }

    grid-column: 1 / -1;
    grid-row: 3;
`;

export const HeroTitle = styled.h1`
    font-size: 3.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    line-height: 1.1;
    margin-top: 0;
    text-wrap: balance;

    @media ${MOBILE_MEDIA_QUERY} {
        font-size: 2.5rem;
    }
`;

export const LineBreakGroup = styled.span`
    display: inline-block;
`;

export const RealName = styled(LineBreakGroup)`
    display: inline;
    background: linear-gradient(45deg, #ff6b6b, #ff9b3d);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 0 30px rgba(255, 107, 107, 0.3);
`;

export const NickName = styled(LineBreakGroup)`
    background: linear-gradient(-45deg, #ffae6b, #ffec3d);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 0 30px rgba(255, 107, 107, 0.3);
    margin-top: 0.5rem;
`;

export const HeroSubtitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 300;
    margin-bottom: 1.5rem;
    opacity: 0.9;

    @media ${MOBILE_MEDIA_QUERY} {
        margin-bottom: 0;
    }
`;

export const HeroDescription = styled.div`
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 2rem;
    opacity: 0.8;
`;

export const HeroActions = styled.div`
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
`;

export const HeroActionsRow = styled.div`
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
`;
